function Column_form_element(element) {
  this.$element = $(element);
  this.dirty = false;

  this.selectors = {
    selectCount: 'select[name=count]',
    checkboxDelete: 'input[name=\'columns_delete[]\']',
    closePopup: 'button#abort'
  };

  this.triggers = {
    afterLoaded: 'i4:afterLoaded'
  };

  this.init = function () {
    this.$formParent = this.$element.parents(this.selectors.formParent);
    this.$selectCount =  this.$element.find(this.selectors.selectCount);
    this.$checkboxDelete = this.$element.find(this.selectors.checkboxDelete);
    this.$closePopup = this.$element.find(this.selectors.closePopup);

    this.$checkboxDelete.on('click', this.$onCheckboxDeleteClick.bind(this));
    this.$closePopup.on('click', this.abort.bind(this));

    this.$formParent.on(this.triggers.afterLoaded, (function () {
      this.updateView();
    }).bind(this));
  };

  this.$onCheckboxDeleteClick = function () {
    var checked = this.$element.find(this.selectors.checkboxDelete + ':checked');
    this.deleteChecked = (checked.length > 0);

    this.updateView();
  };

  this.updateView = function () {
    if (this.deleteChecked) {
      this.$selectCount.prop('disabled', true);
    } else {
      this.$selectCount.prop('disabled', false);
    }
  };

  this.abort = function(event) {
    window.document.location.reload();
  };
}
